import { Component, Input, OnInit } from '@angular/core';
import { Params } from '@angular/router';

import { NavigationService, ToastService } from '@tripointe/tripointe-cms/services';
import { DataAccessService } from '@tripointe/tripointe-cms/data-access';
import { saveAs } from '@tripointe/tripointe-cms/utils';
import { DataListQueryParams, ExportConfigs } from '@tripointe/tripointe-cms/types';

import {
  fileType,
  COLLECTIONS_CONFIG,
  FILE_EXTENSION,
  DEFAULT_CONFIG_BY_TYPE,
  ExportTypeConfig
} from './export-widget.utils';

@Component({
  selector: 'tp-export-widget',
  templateUrl: './export-widget.component.html',
  styleUrls: ['./export-widget.component.scss']
})
export class ExportWidgetComponent implements OnInit {
  @Input() exportConfigs: ExportConfigs;

  fileType = fileType;
  configByType: Record<fileType, ExportTypeConfig>;

  constructor(
    private navigationService: NavigationService,
    private toast: ToastService,
    private dataAccess: DataAccessService
  ) {}

  ngOnInit(): void {
    this.configByType =
      COLLECTIONS_CONFIG[this.exportConfigs.collectionName].configByType || DEFAULT_CONFIG_BY_TYPE;
  }

  exportData(type: fileType): void {
    this.onGenerationStart(type);

    const params = this.getExportParams();
    this.generateExport(params, type);
  }

  getExportParams(): Params {
    const filters = this.navigationService.getQueryParams(DataListQueryParams.filters);
    const archived = this.navigationService.getQueryParams(DataListQueryParams.archived);
    const sort = this.resolveSortArgs(
      this.navigationService.getQueryParams(DataListQueryParams.sort)
    );

    return {
      ...filters,
      ...this.exportConfigs?.extraVariables,
      ...sort,
      ...(this.exportConfigs.getExportData ? this.exportConfigs.getExportData() : {}),
      archived: !!archived
    };
  }

  private resolveSortArgs(sortParams: Params): Params {
    if (!sortParams) {
      return {};
    }
    const { active, direction } = sortParams;
    if (!!active && !!direction) {
      return {
        sortBy: active,
        order: direction
      };
    }
  }

  generateExport(params: Params, exportType: fileType): void {
    const { exportMutation } = COLLECTIONS_CONFIG[this.exportConfigs.collectionName];

    this.dataAccess
      .update(exportMutation, { exportType, ...params })
      .subscribe(({ data: { exportResponse } }) => {
        if (exportResponse.error) {
          this.toast.error(exportResponse.error);
        } else {
          this.onGenerateSuccess(exportResponse.content, exportType);
        }
      });
  }

  onGenerationStart(type: fileType): void {
    this.toast.info(`${type.toUpperCase()} generation started`);
  }

  onGenerateSuccess(result: string, type: fileType): void {
    const fileName = this.generateFileName(type);
    saveAs(result, fileName);

    this.toast.success(`${type.toUpperCase()} generation completed`);
  }

  generateFileName(type: fileType): string {
    const fileExtension = FILE_EXTENSION[type];

    return `${this.exportConfigs.collectionName}-list.${fileExtension}`;
  }
}
